import { Injectable } from '@angular/core';

import { Rating } from './rating';
import { RATINGS } from './ratings';
import { MOCKRATINGS } from './mock-ratings';

@Injectable()
export class TraditionalRatingService {

  getRatings(): Promise<Rating[]> {
    return Promise.resolve(RATINGS);
  }

  getMockRatings(): Promise<Rating[]> {
    return Promise.resolve(MOCKRATINGS);
  }


}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/sustainability-rating/rating/traditional-rating.service.ts